module.exports = __webpack_public_path__ + "static/media/printguide@2x.80fc4f0d.jpg";